import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isDialogVisible: false,
    usedialogVisible: false,
    isRegister: false, // 是否为注册页面
    isLogin: false, // 初始登录状态
    phoneLastDigits: null // 新增状态：存储手机尾号
  },
  mutations: {
    // 改变弹框的可见性
    setDialogVisible(state, isVisible) {
      state.isDialogVisible = isVisible;
    },
    setusedialogVisible(state, usedialogVisible) {
      state.usedialogVisible = usedialogVisible;
    },
    setUseisRegister(state, isRegister) {
      state.isRegister = isRegister; // 控制表单状态
    },
    SET_LOGIN(state, isLogin) {
      state.isLogin = isLogin; // mutation用于更改登录状态
    },
    // 新增mutation：设置手机尾号
    SET_PHONE_LAST_DIGITS(state, phoneLastDigits) {
      state.phoneLastDigits = phoneLastDigits;
    }
  },
  actions: {
    login({ commit }) {
      commit('SET_LOGIN', true); // 将 isLogin 状态设置为 true
    },
    logout({ commit }) {
      commit('SET_LOGIN', false); // 将 isLogin 状态设置为 false
    },
    openDialog({ commit }) {
      commit('setDialogVisible', true);
    },
    openUseDialog({ commit }) {
      commit('setusedialogVisible', true);
    },
    closeUseDialog({ commit }) {
      commit('setusedialogVisible', false);
    },
    closeDialog({ commit }) {
      commit('setDialogVisible', false);
    },
    // 新增action：设置手机尾号
    setPhoneLastDigits({ commit }, phoneLastDigits) {
      commit('SET_PHONE_LAST_DIGITS', phoneLastDigits);
    }
  },
  getters: {
    isLogin: (state) => {
      return state.isLogin;
    },
    isRegister: (state) => {
      return state.isRegister;
    },
    isDialogVisible(state) {
      return state.isDialogVisible;
    },
    usedialogVisible(state) {
      return state.usedialogVisible;
    },
    // 新增getter：获取手机尾号
    phoneLastDigits(state) {
      return state.phoneLastDigits;
    }
  }
});